import * as React from "react";
import {observer} from "mobx-react";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {CrudPageStore} from "../../stores/CrudPageStore";


@observer
export class FormModal extends React.Component<{store: CrudPageStore}> {
    render() {
        const {isFormModalOpen, closeFormModal, formClass, modelName, selectedId} = this.props.store;

        const formComponent = React.createElement(formClass, {
            onSubmit: () => closeFormModal(true),
            id: selectedId,
        }); 

        return (
            <Modal isOpen={isFormModalOpen} toggle={() => closeFormModal()} centered>
                <ModalHeader toggle={() => closeFormModal()}>{selectedId ? 'Edit' : 'Add'} {modelName}</ModalHeader>
                <ModalBody>
                    {formComponent}
                </ModalBody>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/crud/CrudFormModal.tsx